import "./index.css";
const EditorPreloader = () => {
  return (
    <>
      <div class="dots dot10">
        <div class="dot"></div>
      </div>
    </>
  );
};
export default EditorPreloader;
